export default [
  {
    path: '/question/fertility',
    name: 'question_fertility',
    meta: {
      title: '生育力自测表'
    },
    component: () => import('views/question/index')
  },
  {
    path: '/question/ruijin',
    name: 'ruijin',
    meta: {
      title: '生育力自测表'
    },
    component: () => import('views/question/ruijin')
  },
  {
    path: '/question/aid',
    name: 'question_aid',
    meta: {
      title: '助孕器自测表'
    },
    component: () => import('views/question/index_aid')
  },
  {
    path: '/question/aid_result',
    name: 'question_aid_result',
    meta: {
      title: '助孕器自测表'
    },
    component: () => import('views/question/results_aid')
  }
]